import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import StockRequestForm from "./StockRequestForm";
import StockRequestHistory from "./StockRequestHistory";
import "./StockRequest.css";


function StockRequestSection({ activeCheckIn, onCancel }) {
  const { t } = useTranslation();

  const [mode, setMode] = useState("new");
  const [prefill, setPrefill] = useState(null);
  // Bumping this remounts the form so a fresh prefill is applied cleanly.
  const [formKey, setFormKey] = useState(0);

  const handleRequestAgain = (request) => {
    const items = (request?.items || [])
      .map((item) => ({
        product_id: item.product_id,
        quantity: item.quantity,
        model_name: item.model_name || item.product_name || "",
      }))
      .filter((item) => item.product_id);

    if (items.length === 0) return;

    setPrefill({
      items,
      notes: request?.notes || "",
      sourceId: request?.stock_request_id || null,
    });
    setFormKey((previous) => previous + 1);
    setMode("new");
  };

  const handleNewRequestTab = () => {
    setPrefill(null);
    setFormKey((previous) => previous + 1);
    setMode("new");
  };

  return (
    <div className="sr-section">
      <div className="sr-mode-switch" role="tablist">
        <button
          type="button"
          role="tab"
          aria-selected={mode === "new"}
          className={`sr-mode-btn ${mode === "new" ? "is-active" : ""}`}
          onClick={handleNewRequestTab}
        >
          {t("se.stockRequest.tabs.new", { defaultValue: "New Request" })}
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={mode === "history"}
          className={`sr-mode-btn ${mode === "history" ? "is-active" : ""}`}
          onClick={() => setMode("history")}
        >
          {t("se.stockRequest.tabs.history", { defaultValue: "My Requests" })}
        </button>
      </div>

      {mode === "new" ? (
        <StockRequestForm
          key={formKey}
          activeCheckIn={activeCheckIn}
          prefill={prefill}
          onCancel={onCancel}
          // Land on the history list after submitting, so the promoter can see
          // the request they just raised and track its outcome.
          onSave={() => {
            setPrefill(null);
            setMode("history");
          }}
        />
      ) : (
        <StockRequestHistory
          outletId={activeCheckIn?.outlet_id}
          onRequestAgain={handleRequestAgain}
        />
      )}
    </div>
  );
}

export default StockRequestSection;
